import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";

const predefinedBrands = [
  "Bud Light",
  "Heineken",
  "Corona",
  "Coors Light",
  "Other",
];

const BeerBrandSelector = ({ value, onChange }) => {
  const isOtherSelected =
    typeof value === "string" &&
    value !== "" &&
    !predefinedBrands.includes(value);

  const showCustomField = value === "" || isOtherSelected;

  const handleDropdownChange = (e) => {
    const selected = e.target.value;
    if (selected === "Other") {
      onChange(""); // Switch to custom mode
    } else {
      onChange(selected);
    }
  };

  return (
    <Box
      sx={{
        p: 2,
        border: "1px solid #eee",
        borderRadius: 2,
        backgroundColor: "#fafafa",
        mt: 1,
      }}>
      <Typography variant="subtitle2" gutterBottom>
        Beer Brand
      </Typography>

      <FormControl fullWidth>
        <InputLabel>Choose Brand</InputLabel>
        <Select
          value={showCustomField ? "Other" : value || ""}
          label="Choose Brand"
          onChange={handleDropdownChange}>
          {predefinedBrands.map((brand) => (
            <MenuItem key={brand} value={brand}>
              {brand}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {showCustomField && (
        <>
          <TextField
            fullWidth
            label="Custom Brand"
            placeholder="Enter beer brand"
            sx={{ mt: 2 }}
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
          {value?.trim() && (
            <Typography
              variant="caption"
              color="warning.main"
              sx={{ mt: 1, display: "block" }}>
              The brand must be sold in single cans — we cannot purchase 6-packs
              or larger formats. We’ll do our best to source your selection. If
              unavailable, we may ask you to provide a single can. Please note
              that dropping off a can does not qualify for a discount, refund,
              or partial credit.
            </Typography>
          )}
        </>
      )}
    </Box>
  );
};

export default BeerBrandSelector;
